module.exports = __webpack_public_path__ + "7bdf1ea55e64666df1ee80f929fc506b.svg";